/**
 * Footer — mobile accordion (one panel open at a time)
 */
(function () {
  var accordion = document.querySelector('[data-footer-accordion]');
  if (!accordion) return;

  var items = accordion.querySelectorAll('.footer-accordion__item');

  items.forEach(function (item) {
    item.addEventListener('toggle', function () {
      if (!item.open) return;

      items.forEach(function (other) {
        if (other !== item && other.open) {
          other.open = false;
        }
      });
    });
  });
})();
